<template>
  <div>
    <div class="display-1 font-weight-bold pb-3 text-no-wrap">
      <span v-if="param === 'ssid_hotspot'">Смена названия WI-FI сети</span>
      <span v-if="param === 'wifipassword'">Изменение пароля WI-FI сети</span>
      <span v-if="param === 'ssid_work'">Смена названия закрытой сети</span>
    </div>
    <div class="subtitle-1 pb-3 font-weight-medium">
      <span v-if="param === 'ssid_hotspot'">
        Это то, что увидят посетители в списке доступных Wi-Fi-сетей
      </span>
      <span v-if="param === 'wifipassword'">
        Старый пароль:
        <span v-if="hotspot.wifipassword">{{ hotspot.wifipassword }}</span>
        <span v-else>нет</span>
      </span>
      <span v-if="param === 'ssid_work'">
        Старое название:
        <span v-if="hotspot.ssid_work">{{ hotspot.ssid_work }}</span>
        <span v-else>нет</span>
      </span>
    </div>

    <div v-if="error" class="error--text pb-3 font-weight-medium">
      {{ error }}
    </div>

    <v-form ref="form" @keyup.native.enter="send" @submit.prevent="() => false">
      <label v-if="param === 'ssid_hotspot' || param === 'ssid_work'">
        Новое название
      </label>
      <label v-if="param === 'wifipassword'">Новый пароль</label>
      <v-text-field
        v-model="formParam"
        :rules="[rules.required, rules.noRussians, rules.charsLength]"
        height="42"
        solo
        placeholder=""
      ></v-text-field>

      <v-btn @click="send" class="primary mx-0 px-5" :loading="loading">
        Изменить
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import RequestApi from "../../modules/requestApi";
import Common from "../../modules/common";

export default {
  name: "HotspotEditWifi",

  components: {},

  props: {
    // id хотспота
    id: {
      type: Number,
      required: true
    },
    // параметр для редактирования
    param: {
      type: String
    }
  },

  data: () => ({
    loading: false,
    formParam: "",
    error: false,
    rules: {
      charsLength: v =>
        v.length <= 8
          ? "Не менее 8 символов"
          : v.length >= 30
          ? "Не более 30 символов"
          : true,
      required: v => !!v || "Поле обязательно для заполнения",
      noRussians: v =>
        /^[a-zA-Z0-9_-]+$/.test(v) ||
        "Только символы _, -, цифры и латинские буквы, "
    }
  }),

  computed: {
    // объект с данными по хотспоту
    hotspot() {
      return this.$store.getters.getHotspot(this.id);
    }
  },

  methods: {
    /**
     * Редактирует настройки wi-fi сети на микротике
     */
    send() {
      // редактирование настроек производится по id сервиса ЕСС
      let params = {
        id: this.hotspot.id,
        cl_service_id: this.hotspot.cl_service_id
      };
      this.error = false;

      if (this.$refs.form.validate()) {
        this.loading = true;
        params[this.param] = this.formParam;
        this.$store
          .dispatch("editHotspotWifi", params)
          .then(() => {
            // редактирование проходит в течение нескольких секунд
            // на это время блокируем кнопку редактировать
            this.loading = false;
            // открываем сообщение
            this.$store.dispatch("popupInfoOpen", {
              text: "Параметр успешно изменен"
            });
            // закрываем popup
            this.$emit("closeDialog");

            if (this.param === "ssid_hotspot") {
              // событие в метрике
              Common.sendMetrika("rename");
            }
          })
          .catch(err => {
            // открываем сообщение
            this.error = err;
            this.loading = false;
          });
      }
    },

    hotspotWifiEdit() {
      RequestApi.hotspotWifiEdit();
    }
  }
};
</script>
